import React from 'react';
import { useLang } from '../context/LanguageContext';
import { useContent } from '../context/ContentContext';
import { resolveImg } from '../api';
import { ArrowUpRight } from 'lucide-react';

const TattooGallery = () => {
  const { t, lang } = useLang();
  const { content } = useContent();
  const gallery = content?.gallery || [];

  return (
    <section id="tattoo" className="section-pad bg-white">
      <div className="container-tight">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <span className="eyebrow left">{t.tattoo.eyebrow}</span>
            <h2 className="h-display mt-6" style={{ fontSize: 'clamp(40px, 5vw, 64px)' }}>
              {t.tattoo.title}
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[15px] text-[#3A3A3A] leading-[1.8]">{t.tattoo.subtitle}</p>
          </div>
        </div>
      </div>

      <div id="gallery" className="container-tight">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {gallery.map((g, idx) => {
            const style = lang === 'fr' ? g.styleFr : g.styleEn;
            let aspectRatio = '1/1';
            if (idx === 0) aspectRatio = '3/5';
            else if (idx === 3) aspectRatio = '2/1';
            const extraCls = [
              idx === 0 ? 'md:row-span-2 md:col-span-1' : '',
              idx === 3 ? 'md:col-span-2' : '',
            ].join(' ');
            return (
              <div
                key={g.id}
                className={`image-hover relative group ${extraCls}`}
                style={{ aspectRatio }}
              >
                {g.img && <img src={resolveImg(g.img)} alt={style} className="w-full h-full object-cover" />}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-6">
                  <div className="text-white">
                    <div className="text-[9px] tracking-[0.4em] uppercase text-[#D4B987]">0{idx + 1}</div>
                    <div className="serif text-[22px] mt-1">{style}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-14 flex justify-center">
          <a href="https://www.instagram.com/devil_perceur/" target="_blank" rel="noreferrer" className="btn-ghost">
            {t.tattoo.viewAll} <ArrowUpRight size={14} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default TattooGallery;
